var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql, useQuery } from '@apollo/client';
import { WorkflowStatus } from '../../../types/GloblalTypes';
export var GET_WORKFLOW_STATUS_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getWorkflowStatus($workflowId: String!, $workflowName: WorkflowName!) {\n    getWorkflowStatus(workflowId: $workflowId, workflowName: $workflowName) {\n      status\n      error {\n        message\n      }\n    }\n  }\n"], ["\n  query getWorkflowStatus($workflowId: String!, $workflowName: WorkflowName!) {\n    getWorkflowStatus(workflowId: $workflowId, workflowName: $workflowName) {\n      status\n      error {\n        message\n      }\n    }\n  }\n"])));
export var POLLING_INTERVAL = 3000;
export var useGetWorkflowStatusQuery = function (options, pollingOptions, settledCallbacks) {
    if (options === void 0) { options = {}; }
    var query = useQuery(GET_WORKFLOW_STATUS_QUERY, __assign(__assign({}, options), { pollInterval: POLLING_INTERVAL, notifyOnNetworkStatusChange: true, onCompleted: function (data) {
            var _a, _b, _c, _d;
            if (((_a = data.getWorkflowStatus) === null || _a === void 0 ? void 0 : _a.status) ===
                WorkflowStatus.WORKFLOW_STATUS_IN_PROGRESS ||
                ((_b = data.getWorkflowStatus) === null || _b === void 0 ? void 0 : _b.status) ===
                    WorkflowStatus.WORKFLOW_STATUS_UNSPECIFIED) {
                // we are still working on it...
                pollingOptions.setSuccessPollCount(function (currentCount) { return currentCount + 1; });
                pollingOptions.setIsPollingStatus(true);
            }
            else if (((_c = data.getWorkflowStatus) === null || _c === void 0 ? void 0 : _c.status) ===
                WorkflowStatus.WORKFLOW_STATUS_SUCCESS) {
                // workflow completed; fire the onSuccess callback
                pollingOptions.setIsPollingStatus(false);
                query.stopPolling();
                settledCallbacks.onSuccess();
            }
            else if (((_d = data.getWorkflowStatus) === null || _d === void 0 ? void 0 : _d.status) ===
                WorkflowStatus.WORKFLOW_STATUS_ERROR) {
                // got an error from the workflow status; fire the onError callback
                pollingOptions.setIsPollingStatus(false);
                query.stopPolling();
                settledCallbacks.onError();
            }
        }, onError: function () {
            // the query actually failed for some reason
            pollingOptions.setFailurePollCount(function (currentCount) { return currentCount + 1; });
        } }));
    return query;
};
var templateObject_1;
